import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import PublicLayout from '../layouts/PublicLayout';
import Panel from '../common/Panel';
import { DocusealForm } from '@docuseal/react';
import { useGetDocusealSubmission, useMarkDocusealCompleted } from '../../services/onboarding';

const ProcessingAgreement = () => {
  const { user, updateUser } = useUser();
  const navigate = useNavigate();
  const { data: dsExisting, refetch } = useGetDocusealSubmission({ enabled: !!user });
  const markCompleted = useMarkDocusealCompleted((data) => {
    updateUser({ userType: 'client', _currentClaimId: data.claimId });
  });

  React.useEffect(() => {
    if (!user) {
      navigate('/sign-in', { replace: true });
    }
  }, [user, navigate]);

  React.useEffect(() => {
    if (!user) return; // will redirect above
    if (user.userType !== 'pending_client') navigate('/dashboard', { replace: true });
  }, [user, navigate]);

  React.useEffect(() => {
    if (!user) return;
    const id = setInterval(() => refetch(), 2000);
    return () => clearInterval(id);
  }, [user, refetch]);

  // Accepted transition gap: this renders off the slug alone. If staff void
  // (supersede) the DocuSeal SA while a veteran is parked HERE, the embed
  // shows DocuSeal's own "unavailable" message until they navigate - the
  // /processing timeline stops routing anyone new here the moment the
  // submission is superseded (saState 'legacy_ready' filters it out).
  const submitterSlug = dsExisting?.submitterSlug;

  return (
    <PublicLayout>
      <Row>
        <Col xs={12} sm={{ span: 12 }}>
          <Panel className="mb-3 pb-3">
            {submitterSlug ? (
              <div>
                <DocusealForm
                  src={`https://docuseal.com/s/${submitterSlug}`}
                  onComplete={(data) => {
                    const submissionId = data?.submission?.id || data?.submission_id || dsExisting?.submissionId;
                    markCompleted.mutate({ submissionId });
                  }}
                  sendCopyEmail={false}
                  expand={false}
                  withDownloadButton={false}
                  withSendCopyButton={false}
                />
              </div>
            ) : (
              <div className="text-center text-muted">Preparing signing session...</div>
            )}
          </Panel>
        </Col>
      </Row>
    </PublicLayout>
  );
};

export default ProcessingAgreement;


